module.exports = __webpack_public_path__ + "static/media/Team 26 - Eleos.2b9239e6.png";